import {
  LayoutDashboard, ClipboardList, Car, Users as UsersIcon, FileText, Globe, Printer, Handshake, CalendarDays,
} from "lucide-react";
import { isDev, righeValide, vedeMenuCrm } from "@/lib/ambito";

// Sprint MENU-LATERALE — elenco unico delle voci del menu laterale (usato da Sidebar e dai test)
// Sprint CRM-2A — `separatore: true` mette una linea prima della voce (es. Stampe · linea · Calendario · linea · CRM)
export const VOCI_MENU = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav--", esatta: true },
  { to: "/vehicles", label: "Veicoli", icon: Car, testid: "nav--vehicles" },
  { to: "/anagrafiche", label: "Anagrafiche", icon: UsersIcon, testid: "nav--anagrafiche" },
  { to: "/vendite?tipo=preventivo", label: "Preventivi", icon: FileText, testid: "nav--preventivi" },
  { to: "/vendite?tipo=pratica", label: "Pratiche", icon: ClipboardList, testid: "nav--vendite?tipo=pratica" },
  { to: "/web", label: "WEB", icon: Globe, testid: "nav--web" },
  // Sprint 17 — moduli in bianco: chi vede almeno un'azienda (stesso criterio delle stampe del veicolo)
  { to: "/stampe", label: "Stampe", icon: Printer, testid: "nav--stampe",
    visibile: (user) => isDev(user) || righeValide(user).length > 0 },
  // Sprint CRM-2B — ognuno ha il proprio calendario personale
  { to: "/calendario", label: "Calendario", icon: CalendarDays, testid: "nav--calendario", separatore: true },
  // Sprint CRM-1 — regola D: accesso ad almeno una pipeline oppure almeno un flag CRM. Copre tutte le pagine /crm/...
  { to: "/crm", label: "CRM", icon: Handshake, testid: "nav--crm", separatore: true,
    visibile: (user, crm) => vedeMenuCrm(user, crm?.livelli) },
];

export const vociVisibili = (user, crm) => VOCI_MENU.filter((v) => !v.visibile || v.visibile(user, crm));

// Sprint CRM-1 — se più voci coprono la pagina vince la più specifica
export function vocePiuSpecifica(voci, pathname, search) {
  const att = voci.filter((v) => voceAttiva(v, pathname, search));
  return att.sort((a, b) => b.to.length - a.to.length)[0] || null;
}

// Regola unica: percorso uguale o figlio, e ogni parametro della voce presente con lo stesso valore
export function voceAttiva(voce, pathname, search) {
  const [path, query = ""] = voce.to.split("?");
  const pathOk = voce.esatta
    ? pathname === path
    : pathname === path || pathname.startsWith(`${path}/`);
  if (!pathOk) return false;
  const attuali = new URLSearchParams(search || "");
  for (const [k, v] of new URLSearchParams(query)) {
    if (attuali.get(k) !== v) return false;
  }
  return true;
}
